import I18n from "i18n-js";
window.I18n = I18n;
I18n.locale = document.documentElement.getAttribute("lang");
